import React from 'react';
import * as classes from './Carousel.module.scss'
import MediaQuery from 'react-responsive';
import { getFileName } from '../../helpers/FileCatching';
import { trackCustomEvent } from "../../helpers/tracking";

import Slider from "react-slick";

const contentImages = require.context('./images', true, /.*\.(gif|png|jpe?g|svg)$/i);

function ArticleCarousel({content, props, GlobalData}) {
    

    function PrevButton({ onClick, currentSlide, slideCount, }) {
        return <button onClick={()=>{onClick(); onPrevClick();}} className={
            "slick-prev slick-arrow" +
            (currentSlide === 0 ? " slick-disabled" : "")
          }> <img src={getFileName(contentImages,"arrowPrev.svg").default} alt={"Previous"}/></button>;
    }

    function NextButtonDesktop({ onClick, currentSlide, slideCount, }) {
        
        return <button onClick={()=>{onClick(); onNextClick();}} className={
            "slick-next slick-arrow" +
            (currentSlide === slideCount - 3 ? " slick-disabled" : "")
          }><img src={getFileName(contentImages,"arrowNext.svg").default} alt={"Next"}/></button>;

    }

    function NextButtonMobile({ onClick, currentSlide, slideCount, }) {
        
        return <button onClick={()=>{onClick(); onNextClick();}} className={
            "slick-next slick-arrow" +
            (currentSlide === slideCount - 1 ? " slick-disabled" : "")
          }><img src={getFileName(contentImages,"arrowNext.svg").default} alt={"Next"}/></button>;

    }


    let carouselArticles = content.articles.map((item, index) => 
       
        <div key={index} className={classes.Carousel__promoSlot}>
            <div className={classes.Carousel__promoSlot__imageContainer}>
                <a href={item.ctaURL} onClick={() => { onPromoClick(item.title) }}>
                    <img src={getFileName(contentImages,item.image).default} alt={item.imageAlt} className={classes.Carousel__promoSlot__image}/>
                </a>
            </div>
            <a href={item.ctaURL} onClick={() => { onPromoClick(item.title) }}><h3 className={` ${classes.Carousel__promoSlot__header} promoHeading`}>{item.heading}</h3></a>
            <h2 className={` ${classes.Carousel__promoSlot__title} promoTitle`}>{item.title}</h2>
            <a href={item.ctaURL} className={`${classes.Carousel__promoSlot__cta} button`} onClick={() => { onPromoClick(item.title) }}><p>{content.ctaText}</p></a>
        </div>
    )

    function onPrevClick(){
        let trackObject = {
          category: GlobalData.tracking.gaCategory,
          action: "Carousel Click",
          label: "Previous"
        }
        trackCustomEvent(trackObject);
    }

    function onNextClick(){
        let trackObject = {
          category: GlobalData.tracking.gaCategory,
          action: "Carousel Click",
          label: "Next"
        }
        trackCustomEvent(trackObject);
    }

    function onPromoClick(title){
        let trackObject = {
          category: GlobalData.tracking.gaCategory,
          action: "Carousel",
          label: "Article " + title
        }
        trackCustomEvent(trackObject);
    }


    const settingsDesktop = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        customPaging: i => (
            <button></button>
        ),
        prevArrow: <PrevButton />,
        nextArrow: <NextButtonDesktop />
      };

      const settingsTablet = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: i => (
            <button></button>
        ),
        prevArrow: <PrevButton />,
        nextArrow: <NextButtonMobile />,
      };

      const settingsMobile = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        customPaging: i => (
            <button></button>
        ),
        prevArrow: <PrevButton />,
        nextArrow: <NextButtonMobile />,
      };
    
    return (
        <div className={`${classes.Carousel}`}>
            <div className={`${classes.Carousel__wrapper}`}>
                <MediaQuery maxWidth={classes.screenMdMax}>
                    <Slider {...settingsMobile}>
                        {carouselArticles}
                    </Slider>
                </MediaQuery>
                <MediaQuery minWidth={classes.screenMd} maxWidth={classes.screenLgMax}>
                    <Slider {...settingsTablet}>
                        {carouselArticles}
                    </Slider>
                </MediaQuery>
                <MediaQuery minWidth={classes.screenLg}>
                    <Slider {...settingsDesktop}>
                        {carouselArticles}
                    </Slider>
                </MediaQuery>

               
            </div>
            
        </div>
    );
}

export default ArticleCarousel;